import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDkAXSbYNwiiElhagaj2A7YlDrA9bTh0dw",
  authDomain: "african-clothing-e4e64.firebaseapp.com",
  projectId: "african-clothing-e4e64",
  storageBucket: "african-clothing-e4e64.firebasestorage.app",
  messagingSenderId: "9699126438",
  appId: "1:9699126438:web:5e10ecafe9e01cee1b3dec"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);